import React, { Component } from 'react';

const style = {
    'min-height': '600px',
    'background-image': '',
    'background-size': 'cover',
    'background-position': 'center top'
}

export default class Header extends Component {
    render() {
        return (
            <div class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center" style={style}>
                <span class="mask bg-gradient-default opacity-8" />
                <div class="container-fluid d-flex align-items-center">
                    <div class="row">
                        <div class="col-lg-7 col-md-10">
                            <h1 class="display-2 text-white">Edifício Varig</h1>
                            <p class="text-white mt-0 mb-5">Brasília - DF | <span className="badge badge-success">Aberto</span></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Pages/Establishment/Header.js